import { resetDataProvider } from './dataProvider';

const loginUrl = `${process.env.REACT_APP_API_ENTRYPOINT}/auth/login`;
const meUrl = `${process.env.REACT_APP_API_ENTRYPOINT}/auth/me`;

const authProvider = {
    login: async ({ username, password }) => {
        const request = new Request(loginUrl, {
            method: "POST",
            body: JSON.stringify({ username, password }),
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            }),
        });

        const response = await fetch(request);
        if (!response.ok) {
            throw new Error("Invalid credentials");
        }
        const data = await response.json();

        localStorage.setItem("token", data.access_token);
        localStorage.setItem("tokenType", data.token_type || "Bearer");

        // Call /api/auth/me to get roles and permissions
        const meRequest = new Request(meUrl, {
            method: "GET",
            headers: new Headers({
                "Authorization": `${data.token_type} ${data.access_token}`,
                "Accept": "application/json"
            }),
        });

        const meResponse = await fetch(meRequest);
        if (!meResponse.ok) {
            throw new Error("Failed to fetch user details");
        }
        const meData = await meResponse.json();

        localStorage.setItem("roles", JSON.stringify(meData.roles));

        const permissions = {};
        meData.permissions.forEach(perm => {
            permissions[perm] = true;
        });
        localStorage.setItem("permissions", JSON.stringify(permissions));

        return Promise.resolve();
    },

    logout: () => {
        localStorage.removeItem("token");
        localStorage.removeItem("tokenType");
        localStorage.removeItem("roles");
        localStorage.removeItem("permissions");
        // Reset the cached Hydra data provider so the next login
        // re-fetches API documentation with a fresh auth token.
        resetDataProvider();
        return Promise.resolve();
    },

    checkAuth: () =>
        localStorage.getItem("token") ? Promise.resolve() : Promise.reject(),

    checkError: (error) => {
        const status = error.status;
        if (status === 401) {
            localStorage.removeItem("token");
            localStorage.removeItem("tokenType");
            localStorage.removeItem("roles");
            localStorage.removeItem("permissions");
            resetDataProvider();
            return Promise.reject();
        }
        return Promise.resolve();
    },

    getPermissions: () => {
        const roles = JSON.parse(localStorage.getItem("roles") || "[]");
        const permissions = JSON.parse(localStorage.getItem("permissions") || "{}");
        return { roles, permissions };
    },

    hasPermission: (permission) => {
        const { permissions } = authProvider.getPermissions();
        return permissions[permission] === true;
    },

    isAdmin: () => {
        const { roles } = authProvider.getPermissions();
        return roles.includes("administrator");
    },

    canSeeAudio: () => authProvider.hasPermission("read-audio"),
    canSeeVideo: () => authProvider.hasPermission("read-video"),
};

export default authProvider;